

























import Vue from 'vue';

export type ProgressStep = {
  bottomLabel: string;
  completed: boolean;
  icon: any;
  topLabel: string;
};

export default Vue.extend({
  props: {
    steps: {
      default: () => [],
      type: Array as () => ProgressStep[]
    }
  }
});
